import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import img from '../../images/Progress2-new.svg';
import img1 from '../../images/Health-image-new.svg';
import img2 from '../../images/right-icon-new.svg';
import img3 from '../../images/cross-icon-new.svg';

export default function MapPage() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/review');
  };

  return (
    <div className='connect-container-bg'>
      <div className='connect-container-main'>
        <div className='connect-steps-container'>
          <div>
            <h3>2 <span>/ &nbsp;3 steps</span></h3>
          </div>
          <div>
            <h5>83%</h5>
          </div>
        </div>
        <div className='connect-progress'>
          <img src={img} alt="" />
        </div>
        <h2>Map your data</h2>
        <p>We’re matching your uploaded data to the correct fields in the app automatically.</p>
        <div className='health-image-new'>
          <span><img src={img1} alt="" /></span>
        </div>
        <div className='map-content-list'>
          <div className='map-left-data'>
            <h2>Patient Name</h2>
            <h3>Patient Name</h3>
          </div>
          <div className='map-right-data'>
            <img src={img2} alt="" />
            <span>Mapped</span>
          </div>
        </div>
        <div className='map-content-list'>
          <div className='map-left-data'>
            <h2>Test Location</h2>
            <h3>Lab Name</h3>
          </div>
          <div className='map-right-data'>
            <img src={img3} alt="" />
            <span>Needs Review</span>
          </div>
        </div>
        <div className='login-button-container next-button'>
          <button onClick={handleNext}>
            Next
          </button>
        </div>
        <h5>Cancel</h5>
      </div>
    </div>
  );
}
